/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-const */
/* eslint-disable import/prefer-default-export */
export const deepCopy = (obj) => {
  // 判斷傳入為何
  let result = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    // 判斷是否有属性
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      // 判斷屬性是否為物件
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        // 遞迴
        result[key] = deepCopy(obj[key]); // 遞迴複製
      } else if (obj[key] === null) { // 如果是 null，保持 null
        result[key] = null;
      } else { // 不是的話直接賦值 copy
        result[key] = obj[key];
      }
    }
  }
  return result;
};

// export const deepCopy = (obj) => {
//   const result = JSON.parse(JSON.stringify(obj));
//   return result;
// };
